import {INFO_INCOMPLETE_ERROR_TEXT, INFO_INVALID_PHONE_ERROR_TEXT} from "../../helpers/error.helper";

export class StepTwoData {
  activitePro;
  address;
  bic;
  dateCreationEntreprise;
  dateEffetDemande;
  dateEnvoiDocuments;
  email;
  formeLegale;
  fractionnement;
  iban;
  nomRepresentant;
  phone;
  prenomRepresentant;
  raisonSociale;
  siret;
  statutLegal;
}

export function validateStepTwoData(data){
  if (
    !data.address ||
    !data.bic ||
    !data.email ||
    !data.iban ||
    !data.nomRepresentant ||
    !data.statutLegal ||
    !data.dateCreationEntreprise ||
    !data.dateEffetDemande ||
    !data.phone ||
    !data.siret
  ) {
    return INFO_INCOMPLETE_ERROR_TEXT;
  }

  if(data.statutLegal === "PersonneMorale"){
    if(!data.formeLegale ||
    !data.raisonSociale){
      return INFO_INCOMPLETE_ERROR_TEXT;
    }
  }

  if(!/^\d+$/.test(data.phone) ){
    return INFO_INVALID_PHONE_ERROR_TEXT;
  }

  return null;
}